import React from "react";
import Cookies from "js-cookie";
import Map from "../../mapcomponent";
import Api from "../../../../services/ServiceApi";
import { Collapse } from "antd";

const { Panel } = Collapse;
export default function Station_map({ title, language, factupdate, data }) {
  const locale = Cookies.get("locale");
  return (
    <>
      <Collapse
        className="container"
        expandIconPosition="right"
        defaultActiveKey={["1"]}
      >
        <Panel
          header={
            <>
              <img
                src={Api.absoluteUrl(`/icon/bbtec/body/original-station.svg`)}
                alt={title}
                title={title}
              />
              <h4>{title}</h4>
            </>
          }
          key="1"
        >
          <div className="row">
            <span className="col col-4 content-label">
            {factupdate ? language[locale]["site_id"] : null}
            </span>
            <span className="col col-8 content-text">
            {data.job_site_code !== null ? data.job_site_code : `-`}
            </span>
          </div>
          <div className="row">
            <span className="col col-4 content-label">
            {factupdate ? language[locale]["site_name"] : `-`}
            </span>
            <span className="col col-8 content-text">
            {data.job_site_name !== null ? data.job_site_name : `-`}
            </span>
          </div>
          <div className="row">
            <span className="col col-4 content-label">
            {factupdate ? language[locale]["site_grade"] : null}
            </span>
            <span className="col col-8 content-text">
            {data.job_site_grade !== null ? data.job_site_grade : `-`}
            </span>
          </div>
          <div className="row">
            <span className="col col-4 content-label">
            {factupdate ? language[locale]["location_lat"] : null}
            </span>
            <span className="col col-8 content-text">
            {data.location_lat !== null ? data.location_lat : `-`}
            </span>
          </div>
          <div className="row">
            <span className="col col-4 content-label">
            {factupdate ? language[locale]["location_lon"] : null}
            </span>
            <span className="col col-8 content-text">
            {data.location_lon !== null ? data.location_lon : `-`}
            </span>
          </div>
          <div className="block w-100 mx-auto my-2" style={{ height: "200px" }}>
            {data.location_lat && data.location_lon ? (
              Number(data.location_lat) !== 0 ||
              Number(data.location_lon) !== 0 ? (
                <Map
                  center={{
                    lat: Number(data.location_lat),
                    lng: Number(data.location_lon),
                  }}
                  zoom={16}
                ></Map>
              ) : (
                <div className="row d-flex justify-content-center mt-3">
                  <span className="default-thai-font font-italic">
                    ไม่สามารถโหลดแผนที่ได้
                  </span>
                </div>
              )
            ) : (
              <div className="row d-flex justify-content-center mt-3">
                <span className="default-thai-font font-italic">
                  ไม่สามารถโหลดแผนที่ได้
                </span>
              </div>
            )}
          </div>
        </Panel>
      </Collapse>
    </>
  );
}
